module.exports = __webpack_public_path__ + "img/ffb09de03bfb4e69999c451a85d0d01b_mergeImage.efd449f5.png";